export const capitalize = <T extends string>(str: T) => {
  return str.replace(/(^\w{1})|(\s+\w{1})/g, char => char.toUpperCase()) as Capitalize<T>
}
